module.exports = __webpack_public_path__ + "static/media/mainimg-27.12704c10.png";